import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
} from '@material-ui/core';
import React from 'react';
import CheckIcon from '../../../icons/CheckIcon';
import { makeStyles } from '@material-ui/core/styles';
import CopyToClipboardIcon from '../../../icons/copyToClipboardIcon';
import CloseIcon from '../../../icons/CloseIcon';
import { copyToClipboard, envDomainMap } from '../../../utils';

export function MessageDialog({
  handleDialog,
  dialogOpen,
  error,
  referralCode,
  utm
}) {
  const useStyles = makeStyles({
    paper: {
      overflow: 'visible',
    },
  });
  const classes = useStyles();
  const [copied, setCopied] = React.useState(false);

  const copyCode = () => {
    let referralUrl =
      `https://${envDomainMap[process.env.REACT_APP_ENV || 'dev']
      }/auth/signup` || '';
    const condition = (key) => {
      if (key === "utm_source" || key === "utm_medium" || key === "utm_campaign" || key === "utm_term" || key === "utm_content") {
        if (utm[key] !== "") {
          return true;
        }
        return false;
      }
    };
    const utmParams = Object.entries(utm).filter((key) => condition(key[0]) && `${key[0]}=${key[1]}`);
    const newUtm = new URLSearchParams();
    newUtm.append("referralCode", referralCode);
    utmParams.forEach((utm) => {
      newUtm.append(utm[0], utm[1]);
    });
    const stringParam = newUtm.toString();
    if (stringParam.length > 0) {
      referralUrl = referralUrl + "?" + stringParam;
    }
    setCopied(true);
    copyToClipboard(referralUrl);
  };

  return (
    <Dialog
      onClose={handleDialog}
      aria-labelledby='simple-dialog-title'
      open={dialogOpen}
      className='w-full'
      fullWidth={true}
      PaperProps={{
        className: classes.paper,
      }}
    >
      <div
        className='absolute'
        style={{
          top: '-45px',
          left: '50%',
          transform: 'translateX(-50%)',
        }}
        onClick={handleDialog}
      >
        <CheckIcon />
      </div>
      <div
        className='absolute right-2 top-2 cursor-pointer'
        onClick={handleDialog}
      >
        <CloseIcon />
      </div>
      <div className='pt-8' />
      <DialogTitle id='simple-dialog-title' className='text-center'>
        Referral Url Successfully Generated
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <div className='text-center'>
            <p className='mb-8'>
              Copy the generated link and use it elsewhere. This link will be
              found in the generate tiny URL page unless its reset.
            </p>
            <Tooltip title={copied ? 'Copied' : 'Copy URL'}>
              <Button
                variant='contained'
                color='primary'
                style={{
                  padding: '10px 25px',
                }}
                onClick={() => copyCode()}
                startIcon={<CopyToClipboardIcon />}
              >
                Copy referral link
              </Button>
            </Tooltip>
          </div>
        </DialogContentText>
        <span className='text-sm text-red-500 mb-4 inline-block'>{error}</span>
      </DialogContent>
    </Dialog>
  );
}
